// extracted by mini-css-extract-plugin
module.exports = {"description":"leave-organization_description__vWpHz","submit":"leave-organization_submit__1kk2y","orgName":"leave-organization_orgName__2NErn"};